export type SearchCardTreatment = (typeof SearchCardTreatment)[keyof typeof SearchCardTreatment];

export const SearchCardTreatment = {
  legacy: 'legacy',
  simplified: 'v1_base',
  engagement: 'v1_engagement',
} as const;
